import axios from 'axios';
import authConfig from '@/../auth_config.json';

let processor = axios.create({
    baseURL: authConfig.processorDomain,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`
    }
})

processor.interceptors.request.use(function (config) {
    let token = localStorage.getItem("access_token");
    let language = localStorage.getItem("language");
    if (!language) language = "vi-VN";
    config.headers["Accept-Language"] = language;
    if (token) {
        config.headers["Authorization"] = "Bearer " + token;
    }
    return config
});
processor.interceptors.response.use(function (config) {
        if (config && config.status === 401) {
            localStorage.clear();
            return this.$router.push("/pages/login");
        }
        let token = localStorage.getItem("access_token");
        let language = localStorage.getItem("language");
        if (!language) language = "vi-VN";
        config.headers["Accept-Language"] = language;
        if (token) {
            config.headers["Authorization"] = "Bearer " + token;
        }
        return config;
    },
    function (error) {
        if (error && error.response.status === 401) {
            localStorage.clear();
            return location.reload();
        }
        return Promise.reject(error)
    })
export default processor;
